import React, { useState, useEffect } from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { faArrowUp } from '@fortawesome/free-solid-svg-icons'
import './style.css'

export const ScrollTop = () => {
  const [offSetY, setOffsetY] = useState(window.pageYOffset);
  const handleScroll = () => setOffsetY(window.pageYOffset);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {window.removeEventListener("scroll", handleScroll);};
  }, []);

  return (
    <div>
      {offSetY > 1000 && (
          <FontAwesomeIcon onClick={() => scrollToTop()} className="ScrollToTopBox" icon={faArrowUp} />
      )}
    </div>
  );
};
